import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
export function Close() {
  return <section className="w-full border-y-4 border-gold bg-navy" data-id="element-36" data-mp="1zyh2w7skw2x2">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-37" data-mp="1uy2xkxid372q">
        <h2 className="font-display font-bold uppercase text-white text-3xl sm:text-5xl" data-id="element-38" data-mp="1v05w65xky8j2">
          Stop improvising.{' '}
          <span className="text-gold" data-id="element-39" data-mp="1kzwx8kc7e8zz">Start coaching from a system.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-white/75" data-id="element-40" data-mp="1g9ghgtkwubag">
          Tryouts, pre-season, stunts, competition, game day, off-season.
          Written, sequenced, printable.
        </p>

        <div className="mt-7" data-id="element-41" data-mp="178qpy22on72j">
          <Countdown size="sm" tone="dark" data-id="element-42" data-mp="179jpahzbauan" />
        </div>

        <div className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-2xl border border-gold bg-gold/10 px-5 py-4 text-left" data-id="element-43" data-mp="176xiikk8with">
          <div data-id="element-44" data-mp="xbvrfj6et6o9">
            <span className="block text-[10px] font-bold uppercase tracking-widest text-gold" data-id="element-45" data-mp="xbck0wedy0oh">
              Complete package
            </span>
            <span className="text-[15px] font-bold text-white" data-id="element-46" data-mp="419813wbgoor">
              Cheer Coach Pro — 6 Volumes + 5 Bonuses
            </span>
          </div>
          <div className="flex items-baseline gap-2.5" data-id="element-47" data-mp="3lj27igl83ebe">
            <span className="text-[15px] text-white/60 line-through" data-id="element-48" data-mp="3qfiuv8kllonf">$90</span>
            <span className="font-display text-4xl leading-none text-white" data-id="element-49" data-mp="i0s2wv04a3j4">
              $27
            </span>
          </div>
        </div>

        <div className="mx-auto mt-5 max-w-lg" data-id="element-50" data-mp="myagwzszr8xz">
          <CtaButton data-id="element-51" data-mp="82cmblypucnv">Yes, I want the system — $27</CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/60" data-id="element-52" data-mp="84fbk3s1o1rj">
          {['Secure checkout', 'Instant access', '7-day guarantee'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-53" data-mp="2suo75u6nw5wo">
                <span className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-54" data-mp="2xsfyon3e9q0c" />
                {item}
              </li>)}
        </ul>
      </div>
    </section>;
}